import React from 'react';
import Secure from 'assets/livenicons/secure.svg';
import styles from './styles.module.scss';

export const CardSecure = () => {
  return (
    <div className={styles.containerCardSecure}>
      <div className={styles.cardSecure}>
        <img src={Secure} alt="" />
        <p>Pay Safe & Secure</p>
      </div>
    </div>
  );
};
